/* lua.js generated code 0.3.0 */

var MarkLogic = require("clover/panelBusLogic/MarkLogic")
var MarkButton = xClass("MarkButton", function () {
    var __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/homeScene_icon_signIn.csb")
})
MarkButton.prototype.init = function () {
    var self = this
    let oldBtn = self.getChildByName("icon")
    let pos = oldBtn.getPosition()
    oldBtn.setPosition(pos.x - 10, pos.y - 12)
    var btn = UIButton.create(oldBtn, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenSignIn))
    self.btn = btn
    self.btn.nodeExist = true

    // self.getChildByName("txt").setPositionX(self.getChildByName("txt").getPositionX() - 5)
    let label = self.getChildByName("txt")
    let newText = cc.LabelTTF.create('签到', FONT_DEF.sidebox)
    newText.x = -1
    newText.y = -47
    label.removeFromParent(true)
    self.addChild(newText, 2, "txt")
}
MarkButton.prototype.onOpenSignIn = function () {
    var self = this
    cc.log("CURRENT_TIME", os.date("%c", Localhost.time() / 1000))
    self.btn.setEnabled(false)
    DCAssist.dc4ClickIcon("Mark", "click_icon")
    MarkLogic.create().start(function () {
        if (self.btn != null && self.btn.nodeExist) {
            self.btn.setEnabled(true)
        }
    })
}

MarkButton.prototype.ctor = function () {
    this.init()
}
// MarkButton.create = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var self = this
//     var instance = MarkButton.new()
//     assert(instance)
//     if (instance) {
//         instance.init()
//     }
//     return instance
// }
module.exports = MarkButton
